import { createContext, useContext } from 'react'

type FormErrors = Record<string, string>

const FormErrorContext = createContext<FormErrors>({})

export function FormErrorProvider({ errors, children }: { errors?: FormErrors, children: React.ReactNode }) {
  return (
    <FormErrorContext.Provider value={errors || {}}>
      {children}
    </FormErrorContext.Provider>
  )
}

export function useFieldError(name: string): string | undefined {
  const errors = useContext(FormErrorContext)
  return errors[name]
}
